var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 5.56718C19.5833 5.75963 19.5833 6.24075 19.25 6.4332L14.75 9.03128C14.4167 9.22373 14 8.98317 14 8.59827V7.00019H6V14.0002C6 14.5525 5.55228 15.0002 5 15.0002C4.44772 15.0002 4 14.5525 4 14.0002V7.00019C4 5.89562 4.89543 5.00019 6 5.00019H14V3.40211C14 3.01721 14.4167 2.77665 14.75 2.9691L19.25 5.56718ZM18 19.0002C19.1046 19.0002 20 18.1048 20 17.0002V10.0002C20 9.44791 19.5523 9.00019 19 9.00019C18.4477 9.00019 18 9.44791 18 10.0002L18 17.0002L10 17.0002V15.4019C10 15.017 9.58333 14.7765 9.25 14.9689L4.75 17.567C4.41667 17.7594 4.41667 18.2406 4.75 18.433L9.25 21.0311C9.58333 21.2235 10 20.983 10 20.5981V19.0002L18 19.0002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.234520d1.svg";
export { ForwardRef as ReactComponent };